import MSlice from "../../helper/MSlice";

const notificationSlice = new MSlice({
    name: "notification"
});

export const notificationActions = notificationSlice.getActions();
export default notificationSlice.getReducer();
